<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="true" :is-full-page="false"></loading>
    <div class="block-wrapper" :key="currentInbox">
      <div class="block" v-for="demo in currentInbox" :key="demo.id">
        <div class="block--content">
          <div class="container">
            <div class="row">
              <div class="col-6 col-md-3 content--center">
                <div class="block--content-item">
                  <div>
                    <div class="demo--track-title">{{ demo.track_name }}</div>
                    <div class="demo--artist-name">{{ demo.artist_name }}</div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-2 content--center">
                <div class="block--content-item">
                  <div class="demo--source-label">
                    {{ demo.page_name }}                  
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3 content--center">
                <div class="block--content-item content--center page--link">
                  <div class="page--url">
                    <a :href="'mailto:' + demo.artist_email" target="_blank">
                      {{ demo.artist_email
                    }}<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" height="11px" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-3 col-lg-2 content--center">
                <div class="block--content-item content--center">
                  <span v-if="getDemoDate(demo.created_at) == 'Today'"><strong>{{ getDemoDate(demo.created_at) }}</strong></span>
                  <span v-else>{{ getDemoDate(demo.created_at) }}</span>
                </div>
              </div>
              <div class="col-3 col-md-2 content--center">
                <div class="block--content-item content--center">
                  <div class="demo--select" v-if="inbox != 'inbox'">
                    <div style="width:120px; float: left; margin-right: 1em;">
                      <select v-model="demo.status" @change="updateStatus($event, demo)">
                        <option value="open">Open</option>
                        <option value="removed">Declined</option>
                        <option value="approved">Approved</option>
                      </select>
                    </div>
                  </div>
                  <div class="demo--accept" v-if="inbox == 'inbox'" @click="approve(demo)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path d="M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z" />
                    </svg>
                  </div>
                  <div class="demo--decline" v-if="inbox == 'inbox'" @click="decline(demo)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
                    </svg>
                  </div>
                  <router-link class-active="navigation--top-link-active" class="navigation--top-link text--small" :to="{ name: 'DemoDetail', params: { id: demo.id } }">
                    <div class="demo--options" @click="options(demo)">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 408 408" style="enable-background:new 0 0 408 408;" xml:space="preserve">
                        <g>
                          <g id="more-vert">
                            <path d="M204,102c28.05,0,51-22.95,51-51S232.05,0,204,0s-51,22.95-51,51S175.95,102,204,102z M204,153c-28.05,0-51,22.95-51,51
                        s22.95,51,51,51s51-22.95,51-51S232.05,153,204,153z M204,306c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51
                        S232.05,306,204,306z" />
                          </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                      </svg>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 content--center">
                <div class="block--content-item player--audio" style="width: 100%">
                  <div class="demo--player" style="width: 100%">
                    <NativePlayer v-if="demo.demo_url != null" autoplay="false" :file="demo.demo_url"></NativePlayer>

                    <a style="text-decoration: none;" :href="demo.soundcloud_url" target="_blank">
                      <div class="demo--soundcloud" v-if="demo.soundcloud_url != null"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" width="20" fill="white" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                          <g>
                            <g>
                              <path d="M432,240c-5.696,0-11.296,0.608-16.672,1.76C408.128,169.024,346.592,112,272,112c-8.832,0-16,7.168-16,16v256
                    c0,8.832,7.168,16,16,16h160c44.128,0,80-35.872,80-80C512,275.904,476.128,240,432,240z" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M208,144c-8.832,0-16,7.168-16,16v224c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V160
                    C224,151.168,216.832,144,208,144z" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M144,208c-8.832,0-16,7.168-16,16v160c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V224
                    C160,215.168,152.832,208,144,208z" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M80,208c-8.832,0-16,7.168-16,16v160c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V224C96,215.168,88.832,208,80,208z" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M16,256c-8.832,0-16,7.168-16,16v96c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16v-96C32,263.168,24.832,256,16,256z" />
                            </g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                        </svg>
                        Play on Soundcloud</div>
                    </a>
                    <a style="text-decoration: none;" :href="demo.dropbox_url" target="_blank">
                      <div class="demo--dropbox" v-if="demo.dropbox_url != null"><svg version="1.1" width="20" fill="white" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                          <g>
                            <g>
                              <polygon points="361.376,0 256,88.672 407.872,183.168 512,99.136 		" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <polygon points="150.624,0 0,99.104 104.16,183.168 256,88.672 		" />
                            </g>
                          </g>
                          <g>
                            <g>
                              <g>
                                <polygon points="0,267.232 150.624,366.368 256,277.696 104.128,183.168 			" />
                                <polygon points="407.84,183.168 256,277.696 361.376,366.368 512,267.232 			" />
                              </g>
                            </g>
                          </g>
                          <g>
                            <g>
                              <path d="M368.992,399.648c-2.656,1.76-5.728,2.624-8.768,2.624c-3.68,0-7.328-1.28-10.304-3.744L256,319.488l-93.92,79.04
                    c-5.408,4.544-13.184,4.992-19.104,1.12L96,368.736V416l160.32,96L416,416v-47.296L368.992,399.648z" />
                            </g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                          <g>
                          </g>
                        </svg>


                        Play on Dropbox</div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-3"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="block--empty" v-if="currentInbox.length === 0">

        <svg width="100%" height="100%" viewBox="0 0 1200 1200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
          <g>
            <g transform="matrix(1,0,0,1,1.20083,-99.7852)">
              <path d="M357.893,1034.74C336.715,1030.16 82.254,988.896 100.985,684.556C119.715,380.215 143.227,288.69 242.158,255.205C341.088,221.72 581.571,63.273 770.279,213.931C958.987,364.589 1162.62,499.715 1081.81,740.273C1001,980.831 987.773,1061.07 776.942,1048.8C685.055,1043.45 612.793,1044.23 552.167,1045.01C473.689,1046.02 414.708,1047.03 357.893,1034.74Z" style="fill:rgb(249,249,249);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M718.955,582.381C709.853,681.538 621.778,754.801 522.623,745.699C423.468,736.598 350.204,648.524 359.305,549.368C368.407,450.212 456.482,376.948 555.637,386.05C654.792,395.151 728.057,483.225 718.955,582.381ZM871.128,972.687C876.019,968.619 878.8,962.95 879.339,957.077C879.878,951.203 878.177,945.125 874.107,940.232L699.83,730.727C737.789,693.782 763.301,643.69 768.51,586.93C780.121,460.45 686.666,348.104 560.186,336.494C433.706,324.884 321.36,418.339 309.75,544.819C298.14,671.299 391.594,783.645 518.073,795.255C566.613,799.711 613.06,788.679 652.541,766.26L663.439,759.053L838.673,969.708C846.812,979.493 861.342,980.827 871.128,972.687Z" style="fill:rgb(239,239,239);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M336.127,456.666C326.88,476.224 318.663,496.441 312.862,517.306C307.501,536.587 305.738,556.198 306.555,576.167C308.093,613.739 319.067,650.708 338.145,683.102C376.344,747.967 445.046,790.869 520.112,796.593C567.427,800.2 619.209,789.655 659.154,763.239C661.178,761.9 656.366,762.377 655.429,762.998C618.378,787.5 570.725,797.435 526.802,794.767C490.637,792.57 455.217,781.724 424.072,763.239C422.844,762.51 421.622,761.77 420.408,761.017C359.402,723.217 318.475,657.381 312.101,585.841C310.171,564.18 311.009,542.221 316.406,521.099C322.157,498.592 330.986,476.822 340.9,455.852C341.299,455.008 336.734,455.381 336.127,456.666Z" style="fill:rgb(230,145,23);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M666.004,765.707C688.687,792.976 711.371,820.245 734.055,847.514C765.345,885.128 796.635,922.743 827.924,960.358C830.709,963.706 833.424,967.132 836.289,970.413C848.188,984.039 870.616,980.607 879.252,965.152C879.662,964.418 875.183,964.704 874.479,965.965C866.393,980.434 849.631,979.208 839.883,967.592C836.769,963.883 833.688,960.146 830.591,956.423C817.65,940.865 804.708,925.307 791.766,909.75C759.142,870.531 726.518,831.313 693.894,792.094C686.111,782.737 678.328,773.381 670.544,764.024C669.752,763.072 665.185,764.723 666.004,765.707Z" style="fill:rgb(230,145,23);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M446.848,411.976C497.035,381.528 560.185,378.209 613.333,403.116C655.752,422.995 689.39,459.462 705.856,503.312C715.398,528.723 718.915,556.014 716.54,583.028C716.474,583.787 721.237,583.251 721.37,581.735C725.793,531.424 708.958,481.068 674.986,443.65C640.47,405.633 590.628,383.975 539.318,384.254C505.388,384.438 472.095,394.158 443.123,411.735C441.072,412.979 445.897,412.553 446.848,411.976Z" style="fill:rgb(106,121,168);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M731.192,565.103C722.09,664.259 634.015,737.523 534.86,728.421C435.706,719.319 362.441,631.245 371.542,532.089C380.645,432.933 468.719,359.669 567.874,368.771C667.029,377.873 740.294,465.947 731.192,565.103ZM883.365,955.409C888.257,951.34 891.037,945.671 891.576,939.798C892.116,933.924 890.414,927.847 886.344,922.954L712.067,713.448C750.026,676.503 775.538,626.411 780.748,569.652C792.358,443.172 698.903,330.826 572.423,319.216C445.943,307.606 333.597,401.06 321.987,527.54C310.377,654.021 403.831,766.366 530.312,777.977C578.85,782.432 625.298,771.4 664.778,748.981L675.676,741.774L850.91,952.43C859.049,962.215 873.58,963.549 883.365,955.409Z" style="fill:white;fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M885.358,956.017C895.919,946.614 896.62,931.795 887.786,920.992C884.902,917.466 881.958,913.987 879.045,910.485C865.88,894.659 852.715,878.832 839.55,863.006C805.895,822.548 772.24,782.09 738.585,741.632C730.486,731.896 722.387,722.16 714.288,712.424C714.212,712.968 714.136,713.512 714.06,714.057C751.668,677.209 776.179,628.353 782.485,576.011C787.976,530.437 779.693,483.767 758.724,442.928C738.67,403.873 707.545,370.804 669.688,348.545C630.644,325.587 585.12,314.635 539.909,316.906C495.565,319.134 452.219,334.377 416.103,360.174C380.196,385.822 351.765,421.602 335.295,462.57C318.196,505.1 314.064,552.52 323.666,597.353C332.953,640.711 355.01,681.043 386.325,712.414C417.838,743.986 458.276,766.149 501.932,775.419C555.525,786.799 612.306,778.954 660.652,753.103C666.432,750.013 671.781,746.361 677.243,742.749C675.98,742.766 674.718,742.782 673.455,742.799C695.91,769.793 718.365,796.787 740.82,823.782C772.986,862.449 805.151,901.116 837.317,939.784C840.88,944.068 844.414,948.379 848.009,952.637C857.453,963.82 873.357,965.44 884.932,956.383C887.511,954.366 883.56,953.055 881.797,954.434C871.478,962.508 859.371,958.906 851.62,949.588C848.277,945.569 844.934,941.551 841.591,937.532C828.044,921.247 814.498,904.962 800.951,888.678C767.818,848.847 734.685,809.016 701.551,769.185C693.666,759.706 685.782,750.228 677.897,740.75C677.003,739.674 675.077,740.159 674.108,740.799C593.882,793.855 485.615,787.442 410.591,728.046C340.703,672.715 308.814,579.504 330.201,492.967C351.368,407.316 422.84,339.742 509.614,323.624C598.094,307.189 689.705,346.47 739.976,420.788C764.37,456.852 778.216,499.768 779.225,543.316C780.396,593.906 764.667,644.291 734.481,684.955C727.104,694.893 718.911,704.181 710.073,712.84C709.65,713.256 709.428,713.971 709.845,714.473C730.992,739.894 752.138,765.315 773.284,790.736C805.087,828.966 836.889,867.197 868.691,905.428C873.055,910.674 877.42,915.921 881.784,921.167C882.537,922.072 883.317,922.961 884.045,923.885C891.66,933.554 890.56,946.619 881.371,954.8C879.188,956.744 883.906,957.31 885.358,956.017Z" style="fill:rgb(230,145,23);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M728.756,565.326C721.703,639.039 668.883,702.676 597.023,721.708C524.472,740.923 446.152,710.688 404.153,648.818C362.159,586.955 363.449,502.83 407.742,442.48C452.077,382.074 531.409,355.447 603.126,377.526C673.083,399.062 724.001,463.591 729.103,536.54C729.774,546.131 729.598,555.752 728.756,565.326C728.553,567.642 733.452,566.878 733.628,564.88C740.324,488.714 697.633,414.601 627.896,382.832C558.825,351.366 475.452,366.778 421.797,420.295C367.235,474.717 352.815,560.361 387.214,629.452C421.227,697.771 496.119,738.449 571.986,729.612C646.285,720.959 709.858,666.186 728.63,593.66C731.076,584.214 732.699,574.589 733.628,564.88C733.849,562.569 728.947,563.326 728.756,565.326Z" style="fill:rgb(106,121,168);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M552.784,727.445C494.368,727.446 437.685,698.215 404.153,648.818C362.159,586.955 363.449,502.83 407.742,442.48C408.162,441.909 408.587,441.336 409.013,440.771C419.422,429.965 431.144,420.475 443.887,412.538C444.953,412.511 446.377,412.262 446.848,411.976C474.699,395.08 506.543,386.537 538.453,386.537C564.045,386.537 589.678,392.031 613.333,403.116C655.752,422.995 689.39,459.462 705.856,503.312C715.398,528.723 718.915,556.014 716.54,583.028C716.52,583.259 716.947,583.37 717.554,583.37C717.943,583.37 718.407,583.325 718.875,583.236C716.818,604.543 711.114,624.637 702.438,642.968C678.897,680.896 641.629,709.894 597.023,721.708C582.397,725.581 567.534,727.445 552.784,727.445Z" style="fill:rgb(252,252,252);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M702.438,642.968C711.114,624.637 716.818,604.543 718.875,583.236C720.075,583.008 721.303,582.494 721.37,581.735C725.793,531.424 708.958,481.068 674.986,443.65C640.691,405.876 591.258,384.252 540.297,384.252C539.968,384.252 539.647,384.252 539.318,384.254C505.388,384.438 472.095,394.158 443.123,411.735C442.149,412.326 442.727,412.54 443.704,412.54C443.763,412.54 443.824,412.539 443.887,412.538C431.144,420.475 419.422,429.965 409.013,440.771C442.999,395.625 496.731,369.836 551.83,369.836C568.983,369.836 586.261,372.333 603.126,377.526C673.083,399.062 724.001,463.591 729.103,536.54C729.774,546.131 729.598,555.752 728.756,565.326C726.081,593.284 716.821,619.793 702.438,642.968Z" style="fill:rgb(247,247,247);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M717.554,583.37C716.947,583.37 716.52,583.259 716.54,583.028C718.71,558.343 715.961,533.426 708.19,509.924C707.456,507.707 706.679,505.503 705.856,503.312C689.39,459.462 655.752,422.995 613.333,403.116C589.678,392.031 564.045,386.537 538.453,386.537C506.543,386.537 474.699,395.08 446.848,411.976C446.377,412.262 444.953,412.511 443.887,412.538C443.824,412.539 443.763,412.54 443.704,412.54C442.727,412.54 442.149,412.326 443.123,411.735C472.095,394.158 505.388,384.438 539.318,384.254C539.647,384.252 539.968,384.252 540.297,384.252C591.258,384.252 640.691,405.876 674.986,443.65C687.78,457.742 698.143,473.668 705.856,490.736C718.623,518.99 724.127,550.371 721.37,581.735C721.303,582.494 720.075,583.008 718.875,583.236C718.407,583.325 717.943,583.37 717.554,583.37Z" style="fill:rgb(255,234,170);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M551.502,729.185C545.999,729.185 540.446,728.934 534.86,728.421C435.706,719.319 362.441,631.245 371.542,532.089C380.132,438.519 459.045,368.007 551.232,368.007C556.736,368.007 562.288,368.258 567.874,368.771C667.029,377.873 740.294,465.947 731.192,565.103C722.603,658.673 643.69,729.186 551.502,729.185ZM409.013,440.771C408.587,441.336 408.162,441.909 407.742,442.48C363.449,502.83 362.159,586.955 404.153,648.818C437.685,698.215 494.368,727.446 552.784,727.445C567.534,727.445 582.397,725.581 597.023,721.708C641.629,709.894 678.897,680.896 702.438,642.968C716.821,619.793 726.081,593.284 728.756,565.326C729.598,555.752 729.774,546.131 729.103,536.54C724.001,463.591 673.083,399.062 603.126,377.526C586.261,372.333 568.983,369.836 551.83,369.836C496.731,369.836 442.999,395.625 409.013,440.771Z" style="fill:rgb(181,188,212);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M568.779,367.273C493.423,360.649 419.339,401.816 386.361,470.181C352.989,539.363 367.787,624.144 422.376,678.087C476.731,731.798 561.347,745.668 630.193,712.632C698.911,679.659 741.152,605.829 733.467,529.79C725.868,454.598 670.014,390.375 596.774,372.014C587.579,369.708 578.213,368.176 568.779,367.273C566.749,367.079 563.714,369.958 566.969,370.269C640.601,377.314 703.742,430.493 723.223,501.889C730.735,529.419 731.232,557.932 725.57,585.051C716.402,628.954 691.087,669.2 653.248,695.693C591.511,738.919 507.201,737.58 446.546,692.971C386.737,648.985 359.823,570.51 380.039,499.079C400.163,427.974 464.558,375.089 538.373,369.926C547.904,369.259 557.455,369.433 566.969,370.269C568.997,370.447 572.037,367.56 568.779,367.273Z" style="fill:rgb(230,145,23);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M614.968,596.119C605.065,584.038 589.939,575.15 575.189,570.647C550.393,563.077 523.025,567.965 501.468,582.02C496.455,585.289 491.399,589.06 487.374,593.535C485.382,595.748 490.029,596.212 491.356,594.738C500.894,584.135 515.175,576.776 528.734,573.128C553.274,566.525 578.951,572.246 599.036,587.526C603.153,590.658 607.23,594.144 610.524,598.163C611.791,599.708 616.413,597.882 614.968,596.119Z" style="fill:rgb(230,145,23);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M496.929,523.123C496.953,518.127 492.922,514.057 487.926,514.033C482.93,514.009 478.861,518.04 478.837,523.036C478.813,528.032 482.843,532.101 487.839,532.125C492.835,532.149 496.905,528.119 496.929,523.123Z" style="fill:rgb(230,145,23);fill-rule:nonzero;" />
            </g>
            <g transform="matrix(1,0,0,1,14.9345,-100.316)">
              <path d="M621.025,523.804C621.049,518.808 617.018,514.739 612.022,514.715C607.026,514.691 602.957,518.721 602.933,523.717C602.909,528.713 606.94,532.783 611.936,532.807C616.932,532.831 621.001,528.8 621.025,523.804Z" style="fill:rgb(230,145,23);fill-rule:nonzero;" />
            </g>
          </g>
        </svg>
        <span class="head login--title" style="opacity: 0.5;">You don't have any submissions here yet.</span>

      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import NativePlayer from "./NativePlayer";
  import axios from "axios";

  export default {
    name: "DemoLoader",
    components: {
      Loading,
      NativePlayer
    },
    data() {
      return {
        demos: this.$globals.demos,
        isLoading: false,

      };
    },

    methods: {
      updateStatus($event, demo) {
        let self = this;
        self.isLoading = true;
        console.log($event.target.value)
        axios
          .patch("/demo/" + demo.id + "?status=" + $event.target.value, {})
          .then((res) => {
            self.$globals.getDemos();
            self.isLoading = false;
            console.log(res);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getDemoDate(timestamp) {
        return this.timeConverter(timestamp);
      },
      approve(demo) {
        let self = this;
        self.isLoading = true;
        axios
          .patch("/demo/" + demo.id + "?status=approved", {})
          .then((res) => {
            self.$globals.getDemos();
            self.isLoading = false;
            console.log(res);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      decline(demo) {
        let self = this;
        axios
          .patch("/demo/" + demo.id + "?status=removed", {})
          .then((res) => {
            self.$globals.getDemos();
            console.log(res);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      timeConverter(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        if (!this.isToday(a)) {
          var months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          var year = a.getFullYear();
          var month = months[a.getMonth()];
          var date = a.getDate();
          var time = date + " " + month + " " + year + " ";
          return time;
        } else {
          return "Today";
        }
      },
      isToday(someDate) {
        const today = new Date();
        return (
          someDate.getDate() == today.getDate() &&
          someDate.getMonth() == today.getMonth() &&
          someDate.getFullYear() == today.getFullYear()
        );
      },
    },
    computed: {
      currentInbox() {
        console.log(this.inbox);
        if (this.inbox == "inbox") {
          console.log(this.$globals.inbox);
          return this.$globals.inbox;
        } else if (this.inbox == "approved") {
          console.log(this.$globals.approved);
          return this.$globals.approved;
        } else if (this.inbox == "declined") {
          console.log(this.$globals.declined);
          return this.$globals.declined;
        } else {
          console.log(this.$globals.inbox);
          return this.$globals.inbox;
        }
      },
    },
    props: {
      inbox: {
        type: String,
        required: true,
      },
    },
  };
</script>